import { render } from "./Dark.vue?vue&type=template&id=635f5515&scoped=true"
const script = {}

import "./Dark.vue?vue&type=style&index=0&id=635f5515&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-635f5515"]])

export default __exports__